const translations = {
    applicationDetails: 'Application Details',
    productDetails: 'Product Details',
    productUsageReportHeader: 'Product Usage Report (WO: {{workOrderNumber}})',
    productUsageReportStandaloneHeader: 'Product Usage Report',
    workOrderReference: 'Work Order {{workOrderKey}}'
};

export default translations;
